import { createContext, useContext, useEffect, useState } from "react";
import { apiLogin, apiRegister, apiMe, setAuthToken } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("dz_token");
    if (t) {
      setAuthToken(t);
      apiMe()
        .then(setUser)
        .catch(() => {
          localStorage.removeItem("dz_token");
          setAuthToken(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const persist = (data) => {
    localStorage.setItem("dz_token", data.access_token);
    setAuthToken(data.access_token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const d = await apiLogin({ email, password });
    persist(d);
    return d.user;
  };

  const register = async (payload) => {
    const d = await apiRegister(payload);
    persist(d);
    return d.user;
  };

  const logout = () => {
    localStorage.removeItem("dz_token");
    setAuthToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
};
